// RTK Query retains the previous warming payload when a later poll fails.
// Errors must take precedence or the page keeps polling behind its spinner.
export function costAnalyticsLoadingState(results) {
  const failed = results.find((result) => result.error);
  if (failed) {
    return {
      isWarming: false,
      progress: 0,
      error: typeof failed.error?.data?.detail === "string"
        ? failed.error.data.detail
        : "Cost analytics could not load. Please retry.",
    };
  }
  const warming = results.filter((result) => result.data?.warming);
  return {
    isWarming: warming.length > 0,
    // A completed endpoint must not mask a still-loading comparison window.
    progress: warming.length
      ? Math.min(...warming.map((result) => result.data.progress || 0))
      : 1,
    error: null,
  };
}
